/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface UserProfileRequest {

    /**
     * User's Twitter profile
     */
    twitter_profile?: string;

    /**
     * User's Facebook profile
     */
    facebook_profile?: string;

    /**
     * User's Google+ profile
     */
    googleplus_profile?: string;

    /**
     * User's Instagram profile
     */
    instagram_profile?: string;

    /**
     * User's LinkedIn profile
     */
    linkedin_url?: string;

    /**
     * The user's location 
     */
    location?: string;

    /**
     * The user's pronouns (comma separated)
     */
    pronouns?: string;

    /**
     * True if user is part of TYT Army
     */
    is_tyt_army?: boolean;

    /**
     * The user's tagline (short description of themselves)
     */
    tagline?: string;

    /**
     * Timestamp when the user's profile was featured in the community
     */
    featured_at?: string;

    /**
     * User's favorite quote
     */
    favorite_quote?: string;

    /**
     * User's favorite TYT memory
     */
    favorite_tyt_memory?: string;

    /**
     * User's favorite inspirational figure
     */
    favorite_inspirational_figure?: string;

    /**
     * User's political views
     */
    political_views?: string;

    /**
     * User's religion or philosophy
     */
    religion_or_philosophy?: string;

    /**
     * Bio blurb
     */
    bio?: string;

    /**
     * Spot.im user ID
     */
    spot_id?: string;

    /**
     * User's username
     */
    username?: string;

    /**
     * Timestamp when user signed up
     */
    signed_up_at?: string;

    /**
     * The user's membership_info
     */
    member_number?: string;

    /**
     * The user's membership_info
     */
    member_since?: string;

    /**
     * User's desired display name
     */
    display_name?: string;

    /**
     * Avatar URL
     */
    avatar?: string;

    /**
     * Cover Photo URL
     */
    cover_photo?: string;

    /**
     * User's first name
     */
    first_name?: string;

    /**
     * User's last name
     */
    last_name?: string;

    metadata?: { [key : string]: any };

    /**
     * An additional email address the user can be reached by
     */
    additional_email?: string;

    /**
     * The user's city
     */
    city?: string;

    /**
     * The user's state
     */
    state?: string;

    /**
     * The user's zip
     */
    zip?: string;

    /**
     * The user's country
     */
    country?: string;

    /**
     * The user's birthday
     */
    birthday?: string;

    /**
     * The user's gender
     */
    gender?: string;

    /**
     * True if user display_name and location can be publicized
     */
    shout_out_opt_in?: boolean;

    /**
     * True if user allows public display of their profile
     */
    is_public?: boolean;

}

@Model('UserProfile')
export class ApiUserProfile extends BaseModel implements UserProfileRequest {

    /**
     * User's Twitter profile
     */
    
    
    twitter_profile: string;

    /**
     * User's Facebook profile
     */
    
    
    facebook_profile: string;

    /**
     * User's Google+ profile
     */
    
    
    googleplus_profile: string;

    /**
     * User's Instagram profile
     */
    
    
    instagram_profile: string;

    /**
     * User's LinkedIn profile
     */
    
    
    linkedin_url: string;

    /**
     * The user's location 
     */
    
    
    location: string;

    /**
     * The user's pronouns (comma separated)
     */
    
    
    pronouns: string;

    /**
     * True if user is part of TYT Army
     */
    
    
    is_tyt_army: boolean;

    /**
     * The user's tagline (short description of themselves)
     */
    
    
    tagline: string;

    /**
     * Timestamp when the user's profile was featured in the community
     */
    
    
    featured_at: string;

    /**
     * User's favorite quote
     */
    
    
    favorite_quote: string;

    /**
     * User's favorite TYT memory
     */
    
    
    favorite_tyt_memory: string;

    /**
     * User's favorite inspirational figure
     */
    
    
    favorite_inspirational_figure: string;

    /**
     * User's political views
     */
    
    
    political_views: string;

    /**
     * User's religion or philosophy
     */
    
    
    religion_or_philosophy: string;

    /**
     * Bio blurb
     */
    
    
    bio: string;

    /**
     * Spot.im user ID
     */
    
    
    spot_id: string;

    /**
     * User's username
     */
    
    
    username: string;

    /**
     * Timestamp when user signed up
     */
    
    
    signed_up_at: string;

    /**
     * The user's membership_info
     */
    
    
    member_number: string;

    /**
     * The user's membership_info
     */
    
    
    member_since: string;

    /**
     * User's desired display name
     */
    
    
    display_name: string;

    /**
     * Avatar URL
     */
    
    
    avatar: string;

    /**
     * Cover Photo URL
     */
    
    
    cover_photo: string;

    /**
     * User's first name
     */
    
    
    first_name: string;

    /**
     * User's last name
     */
    
    
    last_name: string;

    
    
    metadata: { [key : string]: any };

    /**
     * An additional email address the user can be reached by
     */
    
    
    additional_email: string;

    /**
     * The user's city
     */
    
    
    city: string;

    /**
     * The user's state
     */
    
    
    state: string;

    /**
     * The user's zip
     */
    
    
    zip: string;

    /**
     * The user's country
     */
    
    
    country: string;

    /**
     * The user's birthday
     */
    
    
    birthday: string;

    /**
     * The user's gender
     */
    
    
    gender: string;

    /**
     * True if user display_name and location can be publicized
     */
    
    
    shout_out_opt_in: boolean;

    /**
     * True if user allows public display of their profile
     */
    
    
    is_public: boolean;

}
